<template>
	<v-card :loading="loading" class="elevation-0 rounded-xl hover-shadow">
		<div class="d-flex flex-column align-center pa-5 my-4">
			<v-img eager class="mx-auto" width="50" height="50" src="/assets/icon/loading.svg"></v-img>
			<div class="pt-3 text-center cl-secondary">Sedang memuat informasi...</div>
		</div>
	</v-card>
</template>

<script>

export default {
	props: ['loading'],
	components: {
	},
	data() {
		return {
		}
	}
};

</script>